import React, { useState, useEffect } from 'react';
import api from '../services/api';
import ResultCard from '../components/results/ResultCard';
import Scoreboard from '../components/results/Scoreboard';
import './Results.css';

const Results = () => {
  const [eventsWithResults, setEventsWithResults] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Fetch events with their results from backend API
    const fetchResults = async () => {
      try {
        const response = await api.get('/results');
        setEventsWithResults(response.data);
        setLoading(false);
      } catch (error) {
        console.error('Error fetching results:', error);
        setLoading(false);
      }
    };

    fetchResults();
  }, []);

  return (
    <div id="results" className="results-page">
      <div className="container">
        <h1 className="page-title">EVENT RESULTS</h1>

        <Scoreboard />

        {loading ? (
          <div className="loading">Loading results...</div>
        ) : (
          <>
            {/* INDIVIDUAL EVENTS SECTION */}
            <h2 className="section-title neon-red-title" style={{ marginTop: '4rem', textAlign: 'center' }}>
              INDIVIDUAL EVENTS
            </h2>
            <div className="results-container individual-grid">
              {eventsWithResults.filter(({ event }) => event.eventType === 'Individual').length > 0 ? (
                eventsWithResults
                  .filter(({ event }) => event.eventType === 'Individual')
                  .map(({ event, results }) => (
                    <ResultCard key={event._id} event={event} results={results} type="individual" />
                  ))
              ) : (
                <p className="no-results-msg">No individual results available yet.</p>
              )}
            </div>

            {/* GROUP EVENTS SECTION */}
            <h2 className="section-title neon-gold-title" style={{ marginTop: '5rem', textAlign: 'center' }}>
              GROUP EVENTS
            </h2>
            <div className="results-container group-grid">
              {eventsWithResults.filter(({ event }) => event.eventType === 'Group').length > 0 ? (
                eventsWithResults
                  .filter(({ event }) => event.eventType === 'Group')
                  .map(({ event, results }) => (
                    <ResultCard key={event._id} event={event} results={results} type="group" />
                  ))
              ) : (
                <p className="no-results-msg">No group results available yet.</p>
              )}
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default Results;